const AUTHORIZED_ROLES = ['admin', 'agent', 'principal_agent', 'super_admin'];

export const isPrivilegedRole = (userRoles = []) => {
  return userRoles.some(role => AUTHORIZED_ROLES.includes(role));
};

export const findRole = (user, role) => user.roles.includes(role);
